module.exports = __webpack_public_path__ + "assets/en-PickingAudio.mp3";